import customerSaga from '../../../redux/customer/sagas/CustomerSagas';
import { customerReducer } from '../../../redux/customer/reducers/CustomerReducer';
const loadCustomerModule = () => ({
    id: 'Customer',
    reducerMap: {
        customer: customerReducer,
    },
    sagas: [customerSaga],
});
export default loadCustomerModule;
